import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebd86740"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inquiry-check-page" }
const _hoisted_2 = { class: "check-shell" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<section class=\"hero\" data-v-ebd86740><div class=\"seal\" data-v-ebd86740><img alt=\"Logo\" src=\"/web/media/logos/MB_logo_blue.png\" class=\"text-center\" style=\"width:100% !important;\" data-v-ebd86740></div><p class=\"eyebrow\" data-v-ebd86740>Зээлийн мэдээллийн сан</p><h1 data-v-ebd86740>Лавлагаа баталгаажуулах</h1><p class=\"lead\" data-v-ebd86740> Лавлагааны доод хэсэгт байрлах QR код эсхүл баталгаажуулах кодоор лавлагаа хүчинтэй эсэхийг шалгана уу. </p></section>", 1)
const _hoisted_4 = { class: "check-panel" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "field-label",
  for: "verifyId"
}, "Баталгаажуулах код", -1))
const _hoisted_6 = { class: "search-row" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Шалгах ")
const _hoisted_8 = {
  key: 0,
  class: "error-text"
}
const _hoisted_9 = { class: "status-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "eyebrow" }, "Төлөв", -1))
const _hoisted_11 = { class: "info-grid" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Лавласан огноо", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Дуусах огноо", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Зээлдэгч", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Регистр / УБД", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Лавлагааны төрөл", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Лавласан байгууллага", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Лавласан хэрэглэгч", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Баталгаажуулах код", -1))
const _hoisted_20 = {
  key: 1,
  class: "result-card invalid"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "eyebrow" }, "Төлөв"),
    /*#__PURE__*/_createElementVNode("h2", null, "Лавлагаа олдсонгүй")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "status-pill invalid" }, "ОЛДСОНГҮЙ")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "muted" }, " Оруулсан кодоор баталгаажуулалтын мэдээлэл олдсонгүй. QR кодыг дахин уншуулах эсвэл кодоо шалгана уу. ", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_input, {
            id: "verifyId",
            modelValue: _ctx.verifyId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.verifyId) = $event)),
            clearable: "",
            placeholder: "Жишээ: 83CPJUDE9zz3ohxDrfcHEbhtWeccP81772423494",
            onKeyup: _withKeys(_ctx.checkInquiry, ["enter"])
          }, null, 8, ["modelValue", "onKeyup"]),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: _ctx.loading,
            onClick: _ctx.checkInquiry
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.result && _ctx.result.found)
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            class: _normalizeClass(["result-card", { invalid: !_ctx.result.valid }])
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _hoisted_10,
                _createElementVNode("h2", null, _toDisplayString(_ctx.result.valid ? "Хүчинтэй лавлагаа" : "Хүчингүй лавлагаа"), 1)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["status-pill", { invalid: !_ctx.result.valid }])
              }, _toDisplayString(_ctx.result.valid ? "ХҮЧИНТЭЙ" : "ХҮЧИНГҮЙ"), 3)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _hoisted_12,
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.requestedAt || "-"), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_13,
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.expiresAt || "-"), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_14,
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.subjectName || "-"), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_15,
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.registerNo || _ctx.result.identityNo || "-"), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_16,
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.subjectType || _ctx.kindLabel(_ctx.result.inquiryKind)), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_17,
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.requestedOrgName || _ctx.result.requestedOrg || "-"), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_18,
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.requestedBy || "-"), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_19,
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.verifyId), 1)
              ])
            ])
          ], 2))
        : (_ctx.result && !_ctx.result.found)
          ? (_openBlock(), _createElementBlock("section", _hoisted_20, _hoisted_23))
          : _createCommentVNode("", true)
    ])
  ]))
}